import React, { FC } from "react";
import { Control, ControllerFieldState, useController } from "react-hook-form";

import SelectBase, { SelectProps } from "@/components/ui/Form/Select/SelectBase";

export interface SelectControlledProps extends SelectProps {
  control: Control;
}
const InputControlled: FC<SelectControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <SelectBase field={field} fieldState={fieldState} {...rest} />;
};
export default InputControlled;
